import storage from '@zet/utils/storage'

type ReloadType =
  | 'CHANGE_LANGUAGE'
  | 'MIMIC_MODE'
  | 'ERROR_SCREEN'
  | 'UPDATE_RELOAD'
  | 'NORMAL'

type AppSession = {
  getReloadType: ReloadType
  setReloadType: (type: ReloadType) => void
}

const APP_SESSION: AppSession = {
  getReloadType: storage.getObject('RELOAD_TYPE') ?? 'NORMAL',
  setReloadType(type) {
    storage.saveObject('RELOAD_TYPE', type)
  },
}

export { APP_SESSION }
